export default __webpack_public_path__ + "static/media/initDevelops.799f8aa2.png";